import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { setColor, setFont } from "../../assets/styles/styles";
import IntraverseLogoFull from "../landingPages/intraverseLandingPage/IntraverseHomeImages/IntraverseLogoFull.png";
import Button from "../../components/common/button/Button";
import Footer from "../../components/layout/footer/Footer";
import BackgroundContainer from "../../components/common/Backgrounds/BackgroundContainer";
import { isValidEmail } from "../../utils/generalUtils";
import { Input } from "../../components/common/input/Input";
import { CheckBoxMain } from "../../components/common/checkBox/CheckBoxMain";

const GuestLogin = () => {
    const { roomId } = useParams();
    const [emailValue, setEmailValue] = useState("");
    const [emailErrorMsg, setEmailErrorMsg] = useState("");
    const [isEmailError, setIsEmailError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleEmailChange = (e) => {
        const { value } = e.target;
        setEmailValue(value);

        if (isEmailError && value !== "") {
            setIsEmailError(false);
            setEmailErrorMsg("");
        }
    };
    const handleFormValidtion = async () => {
        if (emailValue === "") {
            setIsEmailError(true);
            setEmailErrorMsg("Email is required");
            return false;
        }

        if (!isValidEmail(emailValue)) {
            setIsEmailError(true);
            setEmailErrorMsg("Email must be a valid email address");
            return false;
        }

        return true;
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // setMessage("");
        setIsEmailError(false);
        setEmailErrorMsg("");

        if (!(await handleFormValidtion())) {
            setIsLoading(false);
        }

        // try {
        //     // call guest login API
        // } catch (error) {
        //     console.error("API call error:", error);
        // } finally {
        //     setIsLoading(false);
        // }
    };

    return (
        <BackgroundContainer loginBorder>
            <HeaderDiv>
                <Link to="/">
                    <LoginLogo src={IntraverseLogoFull} alt="Company Logo" />
                </Link>
            </HeaderDiv>
            <ContentContainer>
                <LoginTitle>continue as a guest </LoginTitle>
                <LoginSubtitle>Ready to play as a guest? Start by entering your email.</LoginSubtitle>
                <StyledForm id="formLogin" onSubmit={(e) => onSubmit(e)}>
                    <input type="email" style={{ display: "none" }} />

                    <Input
                        variant="LoginInput"
                        type="email"
                        placeholder="Email address"
                        value={emailValue}
                        onChangeHandler={handleEmailChange}
                    />
                    {isEmailError && !isValidEmail(emailValue) && <ErrorMessage>{emailErrorMsg}</ErrorMessage>}

                    <StyledCheckboxLabel>
                        <CheckBoxMain
                            height={"25px"}
                            width={"25px"}
                            fontSize={16}
                            labelTextRight={
                                <>
                                    I am at least 18 years old and I agree to Intraverse’s{" "}
                                    <YellowText>Privacy Policy</YellowText> and{" "}
                                    <YellowText>Terms and Conditions</YellowText>.
                                </>
                            }
                            onChange={() => {}}
                        />
                    </StyledCheckboxLabel>
                    <Button
                        label="SIGN IN"
                        buttonWidth={"100%"}
                        variant={!isValidEmail(emailValue) ? "DefaultButton" : "PinkButton"}
                        type="submit"
                        disabled={isLoading}
                    >
                        SIGN IN
                    </Button>
                </StyledForm>
                <Footer />
            </ContentContainer>
        </BackgroundContainer>
    );
};

export default GuestLogin;

// ----------------------------------------------------------------------

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    margin-top: -20px;
`;

const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    padding: 20px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        width: 90%;
    }

    @media (max-width: 480px) {
        width: 100%;
    }
`;
const StyledCheckboxLabel = styled.div`
    width: fit-content;
    display: flex;
    padding: 5px 10px 30px 1px;
    margin-top: 10px;
`;

const ErrorMessage = styled.div`
    color: ${setColor.errorColor};
    margin-bottom: 3px;
`;

const LoginLogo = styled.img`
    display: flex;
    align-self: flex-start;
    width: 250px;
    height: auto;
    margin-bottom: 30px;
    margin-left: 10px;

    @media (max-width: 768px) {
        align-self: center;
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
`;
const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    margin-bottom: 40px;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        margin-left: 0px;
        margin-top: 10px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const LoginTitle = styled.h3`
    color: ${setColor.accent4};
    text-align: center;
    font-family: ${setFont.barlowCondensed};
    font-size: 45px;
    margin-top: 3rem;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    word-wrap: break-word;
    @media (max-width: 960px) {
        font-size: 40px;
    }

    @media (min-width: 960px) and (max-width: 1440px) {
        font-size: 40px;
    }
`;

const LoginSubtitle = styled.p`
    color: ${setColor.circularProgress};
    text-align: center;
    font-family: ${setFont.barlow};
    font-size: 18px;
    font-weight: 400;
    margin-top: 1.5rem;
    @media (max-width: 960px) {
        margin: 1rem -10px;
    }
`;
const YellowText = styled.span`
    color: #ffd700;
`;
